// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> amber-ridge
// Generated: 2026-11-04T21:49:37.298Z
// Counts: 0 design, 37 content, 25 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Live Close to the Action in Wasilla</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find warmth and comfort near Wasilla Lake in Wasilla, AK</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Amber Ridge Apartments in Wasilla, AK, comfort finds you at home and beyond. Each apartment offers essentials like granite countertops, energy-efficient appliances, and spacious closets. In the community, friends and neighbors connect in open green spaces, with conveniences like on-site laundry, 24-hour emergency maintenance, and a welcoming barbecue area nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Interested in making Amber Ridge Apartments your new home in Wasilla, AK? Contact our dedicated leasing team for details on availability, tours, or any questions you may have about apartment living in Wasilla.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover flexible floor plan options at Amber Ridge Apartments for renters in Wasilla, AK. Choose between stunning one- and two-bedroom layouts, perfect whether you want space for guests, remote work, or simply plenty of storage. Each home features thoughtful extras like granite countertops and large closets, making daily living feel easier and more enjoyable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Amber Ridge Apartments in Wasilla, AK, through our photo gallery. Picture waking up to sun-filled rooms, prepping meals in your modern kitchen, and winding down among mature trees. From spacious living areas to welcoming community spaces, see how every detail supports a comfy lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Amber Ridge Apartments in Wasilla, AK, just under 50 miles from Anchorage, you’ll find everything at your fingertips. Enjoy everyday convenience with Fred Meyer, Target, Walmart, and Sears nearby for errands, and choose from delicious dining like The Grill or Thai Asian Cuisine. Unwind outdoors at Newcomb Park Wasilla Lake, play at Alcantra Disc Golf Course, or enjoy a night out at The Valley Cinema nearby. With easy access to Parks Highway and Glen Highway, neighborhood living feels relaxed and connected.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Amber Ridge Apartments puts you in the heart of Wasilla, AK. Grab your essentials at Fred Meyer or Target, catch a movie at The Valley Cinema, or enjoy green spaces for strolls with friends or pets. With easy access to Parks Highway and Glen Highway, commuting around Wasilla and beyond is a breeze.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Wasilla, AK? At Amber Ridge Apartments, you’ll come home to a relaxing space near Wasilla Lake, Fred Meyer, Target, and The Valley Cinema. Our community welcomes pets and offers modern homes with features like energy-efficient appliances and large closets. Enjoy the convenience of on-site laundry and community spaces for easy living in a vibrant neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see Amber Ridge Apartments for yourself? Book a guided or virtual tour to explore our one- and two-bedroom layouts. Choose the tour option that suits your schedule, and get to know the welcoming amenities and relaxed community feel. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Can’t make it in person? Take a virtual tour of Amber Ridge Apartments in Wasilla, AK, and get a sense of the neighborhood vibe. Walk through floor plans, see real community spaces, and picture yourself relaxing at home - all from your laptop or phone. Virtual tours let you explore at your own pace and help you imagine life at Amber Ridge, no matter where you are moving from.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Weidner Apartment Homes logo"
      }
    }
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[17].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[17].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "hero.feature_slide_2": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "hero.feature_slide_4": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "hero.feature_slide_5": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-1b9f-7097-a16a-d12adb421ef9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, coffee table, and artwork."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-1b9f-7097-a16a-cc838a38a930.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen area with a breakfast bar and stools, leading to an entryway with two doors."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-4c49-73da-817d-598b6ff33622.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with beige siding and white windows, set against a blue sky with clouds."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-4160-714e-b404-b5ee5bee5694.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with granite countertops, stainless steel sink, white appliances, and wood cabinets."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-1ba4-7149-9e68-614caeb39cba.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A staged bedroom with a queen-size bed, nightstands, and a window."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167168/019d021b-1b9f-7097-a16a-d12adb421ef9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, coffee table, and artwork."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
